import normalizeText from '../../components/normalize_text'

const HIDDEN_CLASS = 'entity-search-hidden'
const MOBILE_VISIBLE_CLASS = 'entity-search-match'

class EntitySearch {
  constructor() {
    this.input = document.querySelector('#entity-search-input')
    if (!this.input) return

    this.counter = document.querySelector('.entity-search-counter')
    this.emptyMessage = document.querySelector('.entity-search-empty')
    this.scrollElement = document.querySelector('.entity-selection .scroll')
    this.items = Array.from(document.querySelectorAll('.entity-selection .nav-item[data-entity-name]'))
    this.total = this.items.length
    this.normalizedNames = new Map(this.items.map((item) => [item, normalizeText(item.dataset.entityName)]))

    this.input.addEventListener('input', () => this.filter())
  }

  filter() {
    const term = normalizeText(this.input.value)
    let matches = 0

    this.items.forEach((item) => {
      const match = this.normalizedNames.get(item).includes(term)
      if (match) matches += 1

      item.classList.toggle(HIDDEN_CLASS, !match)
      item.classList.toggle(MOBILE_VISIBLE_CLASS, term !== '' && match)
    })

    this.updateCounter(term, matches)
    this.emptyMessage.classList.toggle(HIDDEN_CLASS, matches > 0)
    this.updateScroll()
  }

  updateCounter(term, matches) {
    this.counter.textContent = term === '' ? `${this.total} empresas` : `${matches} de ${this.total} empresas`
  }

  updateScroll() {
    if (window.KTUtil && this.scrollElement) window.KTUtil.scrollUpdate(this.scrollElement)
  }
}

export default EntitySearch
